
define('modules/application/wizard/steps/zoneStep/complexZoneStep/automationSimpleZoneStep/zoneModel',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  // Classes
  "../zoneModel",
  "../../../../classes/gaugesAndInterfaces",
  "../../../../classes/controlledLoads",
  "../../../../classes/commands",
  "../../../../classes/traditional",
  "../../../../classes/lightPoints",
  "../../../../classes/engines",
  "../../../../classes/commandPoints",
  "../../../../classes/advancedCommands",
  "../../../../classes/webServer",
  "../../../../classes/integrationDevices",
  "../../../../classes/zigbeeRadio",
  "../../../../classes/automationRemoteControls",
  "../../../../classes/scenariosCommands"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneModel,
  gaugesAndInterfaces,
  controlledLoads,
  commands,
  traditional,
  lightPoints,
  engines,
  commandPoints,
  advancedCommands,
  webServer,
  integrationDevices,
  zigbeeRadio,
  automationRemoteControls,
  scenariosCommands) {

  var automationSimpleZoneStepZoneModel = ZoneModel.extend({


    addConstructors   : function() {
      ZoneModel.prototype.addConstructors.apply(this);
    },


    initialize        : function()  {
      ZoneModel.prototype.initialize.apply(this);
      window.BticinoS4B.eventAggregator.unbind("zoneValidityUpdate:request", this.updateZoneValidity);
      window.BticinoS4B.eventAggregator.bind("zoneValidityUpdate:request", this.updateZoneValidity, this);

      var that     = this,
          len      = this.get("sections") ? this.get("sections").length : 0,
          sections = this.get("sections"),
          i        = 0;

      for(i=0;i<len;i++) {
        var classToInstance      = this.sectionInstancer(sections[i]);
        var zoneEventAggregator  = this.get("zoneEventAggregator");
        var objModel             = null;

        var modelInstance        = null;
        var modelName            = sections[i].name + "Model";
        if (this.get(modelName)===undefined)
        {
          modelInstance = new classToInstance.Model({
            stepEventAggregator :  this.stepEventAggregator,
            zoneEventAggregator :  zoneEventAggregator,
            zoneNumber          :  this.get("number")
          });
          this.set(modelName, modelInstance);
        }
        else if (this.get(modelName).attributes) {
          objModel = this.get(modelName);
        }
        else {
          modelInstance = new classToInstance.Model(_.extend({
            stepEventAggregator :  this.stepEventAggregator,
            zoneEventAggregator :  zoneEventAggregator,
            zoneNumber          :  this.get("number")
          }, this.get(modelName)));
          this.set(modelName, modelInstance);
        }
      }
    },

    sectionInstancer        : function(section)   {
      switch(section.name)
      {
      case "gaugesAndInterfaces"       :
        return gaugesAndInterfaces;
      case "controlledLoads"           :
        return controlledLoads;
      case "commands"                  :
        return commands;
      case "traditional"               :
        return traditional;
      case "lightPoints"               :
        return lightPoints;
      case "engines"                   :
        return engines;
      case "commandPoints"             :
        return commandPoints;
      case "advancedCommands"          :
        return advancedCommands;
      case "webServer"                 :
        return webServer;
      case "zigbeeRadio"               :
        return zigbeeRadio;
      case "integrationDevices"        :
        return integrationDevices;
      case "automationRemoteControls"  :
        return automationRemoteControls;
      case "scenariosCommands"         :
        return scenariosCommands;
      }
    },

    validateRegularZone : function() {
      this.set("valid", true);
    },

    updateZoneValidity: function()
    {

      if (name==="IDS_WAV8_5_1")
        this.validateVdesZone();
      else if (this.get("name")==="IDS_WAV8_5_2")
        this.validateHandsetsZone();
      else
        this.validateRegularZone();

      this.trigger("render:requested");

      this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
    },

    isValid        : function()
    {
      return true;
    },


    deliverCurrent : function() {
    }


  });

  // Required, return the module for AMD compliance
  return automationSimpleZoneStepZoneModel;

});